import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import CardPreview from "@/components/CardPreview";
import Logo from "@/components/Logo";

export default function PublicCard() {
  const { slug } = useParams();
  const [card, setCard] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [lead, setLead] = useState({ name: "", email: "", phone: "", message: "" });
  const [showLead, setShowLead] = useState(false);

  useEffect(() => {
    api.get(`/public/cards/${slug}`).then((r) => setCard(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  const saveContact = () => { window.location.href = `${API}/public/cards/${slug}/vcard`; };

  const submitLead = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/public/cards/${slug}/leads`, lead);
      toast.success("Details shared — thank you!");
      setShowLead(false);
      setLead({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Could not send"); }
  };

  if (notFound) return <div className="min-h-screen flex flex-col items-center justify-center gap-4"><Logo /><p className="text-[#8B9BB4]">Card not found.</p></div>;
  if (!card) return <div className="min-h-screen flex items-center justify-center text-[#8B9BB4]">Loading…</div>;

  return (
    <div className="min-h-screen py-10 px-4 iw-noise relative">
      <div className="relative z-10">
        <CardPreview card={card} onSaveContact={saveContact} onLead={() => setShowLead(true)} />
        <div className="max-w-sm mx-auto mt-6 flex justify-center opacity-70"><Logo size={22} /></div>

        {showLead && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/70" onClick={() => setShowLead(false)}>
            <div className="iw-card p-6 w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
              <h3 className="font-display text-xl font-bold mb-4">Exchange your details</h3>
              <form onSubmit={submitLead} className="space-y-3">
                <input className="iw-input" placeholder="Your name" value={lead.name} onChange={(e) => setLead({ ...lead, name: e.target.value })} required data-testid="lead-name" />
                <input className="iw-input" type="email" placeholder="Email" value={lead.email} onChange={(e) => setLead({ ...lead, email: e.target.value })} data-testid="lead-email" />
                <input className="iw-input" placeholder="Phone" value={lead.phone} onChange={(e) => setLead({ ...lead, phone: e.target.value })} data-testid="lead-phone" />
                <textarea className="iw-input" placeholder="Message (optional)" rows={3} value={lead.message} onChange={(e) => setLead({ ...lead, message: e.target.value })} data-testid="lead-message" />
                <button className="btn-gold w-full py-3 rounded-full" data-testid="lead-submit">Send</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
